import { Injectable } from '@angular/core';
import { BaseService } from '../core/components/base.service';
import { Http, Response, RequestOptions, Headers, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { RequestUtil } from '../util/request.util';
import { SessionUtil } from '../util/session.util';
import { MessageService } from 'primeng/components/common/messageservice';
@Injectable()
export class FotosService extends BaseService<any>{

  private static FOTO_RESOURCE: string = "/fotos";
  private static FOTO_PORHABITACION_RESOURCE: string = "/fotos/habitacion/";
  
  

  constructor(protected http: Http, protected messageService: MessageService) {
    super(http, messageService);
  }

  public saveFoto(foto: any, onSuccess) {
   
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_MULTIPART_FORM_DATA, true);
    let options = new RequestOptions({ headers: headers });
    let formData: FormData = new FormData();
    formData.append("habitacion", JSON.stringify(foto.habitacion));

    if (foto.files != null) {
      for (let file of foto.files) {
        formData.append("imagen", file, file.name);
      }
    }
    if (foto.id == null) {
      this.post(BaseService.URL_BASE + FotosService.FOTO_RESOURCE, formData, options, onSuccess);
    } else {
      formData.append("id", foto.id);
      this.put(BaseService.URL_BASE + FotosService.FOTO_RESOURCE, formData, options, onSuccess);
    }
  }

  public deleteFoto(foto: any, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let options = new RequestOptions({ headers: headers });
    this.delete(BaseService.URL_BASE + FotosService.FOTO_RESOURCE + "/" + foto.id, options, onSuccess);
  }

  public getFoto(id: any, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let options = new RequestOptions({ headers: headers });
    let params: URLSearchParams = RequestUtil.createURLSearchParams();
    this.get(BaseService.URL_BASE + FotosService.FOTO_RESOURCE + "/" + id, params, options, onSuccess);
  }

  public getFotos(fotoFilter: any, first: number, max: number, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let params: URLSearchParams = RequestUtil.createURLSearchParams();
    if (first != null) {
      params.append("first", first.toString());
    }
    if (max != null) {
      params.append("max", max.toString());
    }
    let options = new RequestOptions({ headers: headers });
    this.get(BaseService.URL_BASE + FotosService.FOTO_RESOURCE, params, options, onSuccess);
  }

  public getFotosPorHabitacion(idHabitacion: number, first: number, max: number, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let params: URLSearchParams = RequestUtil.createURLSearchParams();
    
    if (first != null) {
      params.append("first", first.toString());
    }
    if (max != null) {
      params.append("max", max.toString());
    }
    let options = new RequestOptions({ headers: headers });
    this.get(BaseService.URL_BASE + FotosService.FOTO_PORHABITACION_RESOURCE +idHabitacion, params, options, onSuccess);
  }


}



// WEBPACK FOOTER //
// C:/repos/Tulaima/Tulaima-ng/src/app/services/fotos.service.ts